module.exports = __webpack_public_path__ + "media/assets/images/dwpdpa-logo-new-fca4db832f097498595bb56994ff0961.svg";